import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import convApi, { setCsrf } from '@/lib/conversations';
import { useSeo } from '../hooks/useSeo';

// Troca a ligação recebida por email por uma sessão em cookie e limpa o token da URL.
export default function MarketplaceConversationAccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [err, setErr] = useState('');
  const done = useRef(false);

  useSeo({ title: 'Acesso à conversa · Marketplace TVDE', description: 'Acesso seguro à sua conversa.', noindex: true });

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get('t');
    window.history.replaceState({}, '', '/conversas/acesso');
    if (!token) { setErr('Ligação inválida.'); return; }
    (async () => {
      try {
        const res = await convApi.post('/acesso', { token });
        setCsrf(res.data.csrf);
        navigate(res.data.conversation_id ? `/conversas/${res.data.conversation_id}` : '/conversas', { replace: true });
      } catch (e) {
        setErr(e.response?.data?.detail || 'Ligação inválida ou expirada.');
      }
    })();
  }, [params, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm" data-testid="conv-access-page">
        {!err ? (
          <p className="flex items-center justify-center gap-2 text-sm text-slate-600">
            <Loader2 className="h-4 w-4 animate-spin" /> A validar a sua ligação segura...
          </p>
        ) : (
          <>
            <p className="text-sm font-semibold text-red-600" data-testid="conv-access-page-error">{err}</p>
            <Link to="/conversas" className="mt-4 inline-block rounded-xl bg-emerald-600 px-4 py-2 text-sm font-semibold text-white" data-testid="conv-access-page-retry">
              Pedir uma nova ligação
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
